var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlsMobileLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 74,
    viewBox: "0 0 65 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6542 71.6191C54.6542 71.6191 52.4345 68.0901 56.8099 60.2974C61.1853 52.5047 67.9081 39.9854 62.5586 29.6377C62.5586 29.6377 59.9877 34.7796 58.5665 34.7477C58.5665 34.7477 60.1633 25.4859 54.6382 18.1882C49.1131 10.8906 45.057 11.5453 42.4542 7.44137C42.4542 7.44137 42.6937 11.5932 43.3324 12.2319C43.9712 12.8707 31.6274 6.97828 31.1803 0C31.1803 0 18.0062 10.7469 19.3316 28.1526C18.3347 27.6725 17.4853 26.9328 16.8728 26.0112C16.2603 25.0896 15.9071 24.0201 15.8505 22.9149C15.8505 22.9149 11.0599 37.0791 20.6411 46.0854C20.6411 46.0854 18.9484 47.4746 15.4513 43.0833C15.6789 47.2296 17.3775 51.1589 20.2418 54.1655C24.8887 58.8602 29.5196 61.9741 38.4939 64.6888C47.4683 67.4034 47.2288 68.7129 48.4104 69.4794C48.4104 69.4794 26.5814 48.4168 28.9128 10.7948C32.9285 32.7121 41.7167 53.4776 54.6542 71.6191Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0385 21.4618C17.0385 21.4618 18.1244 11.0822 20.2322 9.02224C20.2322 9.02224 20.0246 8.78271 15.2181 12.8068C15.2181 12.8068 4.82252 21.366 5.14189 34.3165C3.76794 32.9335 1.94349 32.0893 0 31.9372C1.00602 32.4162 1.9322 36.0251 2.42723 39.0911C3.48115 45.6063 4.9343 50.7322 7.55315 53.9419C9.7335 56.4283 12.2677 58.5804 15.0744 60.3293C15.0744 60.3293 10.3636 61.2236 7.60105 59.1157C7.60105 59.1157 8.97435 66.5731 24.4319 71.0602C39.8895 75.5474 40.8317 71.9385 46.788 72.6571C46.788 72.6571 44.9197 70.8526 34.0131 67.8665C23.1066 64.8804 18.9068 59.2435 17.1822 57.1196C14.751 54.5547 12.9174 51.4835 11.8131 48.1263C10.7088 44.7692 10.361 41.2092 10.7948 37.7018C11.3944 39.1636 12.4465 40.3947 13.7969 41.2149C13.7969 41.2149 9.00629 29.1586 15.777 18.8589C15.9481 19.8267 16.3849 20.7278 17.0385 21.4618Z",
    fill: "url(#paint1_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 57.9355,
    y1: 15.0356,
    x2: 33.8685,
    y2: 65.4085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FBC926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F8F0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E7D28E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.6568 37.4724) rotate(115.292) scale(28.8011 28.5424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF2BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0D98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3922E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlsMobileLogo);
export default __webpack_public_path__ + "static/media/gls_mobile_logo.59d895c2.svg";
export { ForwardRef as ReactComponent };